import { useEffect } from "react";
import axios from "axios";
import { message } from "antd";

export default function useStoryAssets({
  storyId,
  deletedAssets,
  setDeletedAssets,
  selectedAssets,
  setSelectedAssets,
}) {
  const source = "db";

  // --------------------------------------------------
  // FETCH FILE
  // --------------------------------------------------
  const fetchFile = async (storyId, filename) => {
    if (!filename) return null;

    try {
      const res = await axios.get(`/api/assets/${storyId}/imagefile/${filename}`,
        {
          responseType: "blob",
          withCredentials: true,
        }
      );

      return new File([res.data], filename, { type: res.data.type });
    } catch (err) {
      console.error("Failed file:", filename);
      return null;
    }
  };

  // --------------------------------------------------
  // NORMALIZE FROM DB
  // --------------------------------------------------


  async function fetchAndNormalizeAssets(rawAssets, storyId) {
    return Promise.all(
      rawAssets.map(async (a) => {
        const type = Number(a.type);
  
        const base = {
          id: a.id,
          name: a.name || "",
          png: null,
          mainImageUrl: a.main_img || null,
          type,
          data: [],
        };
  
        const dataTypes = new Set([0, 2, 3, 4, 5]);
  
        if (dataTypes.has(type)) {
          base.data = normalizeSprites(
            typeof a.data === "string"
              ? JSON.parse(a.data)
              : a.data
          );
        }
  
        return base;
      })
    );
  }

  function normalizeSprites(data = []) {
    console.log("data:;:;:;:;", data);
    /*
    if (typeof data === "string") {
      data = JSON.parse(data);
    }*/

    return data.map((item) => ({
      file: null,
      name: item.name,
      url: item.url,
      filename: item.filename,
    }));
  }





  // --------------------------------------------------
  // LOAD EFFECT
  // --------------------------------------------------
  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const url =
          source === "db"
            ? `/api/assets/db/${storyId}`
            : `/api/assets/${storyId}`;

        const res = await axios.get(url, { withCredentials: true });

        const raw = res.data.assets || res.data;

        console.log("RAW ASSETS FROM API:", raw);

        if (!raw?.length) return;

        const normalized = await fetchAndNormalizeAssets(
          raw,
          storyId
        );

        if (isMounted) setSelectedAssets(normalized);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [storyId]);

  // --------------------------------------------------
  // UPDATE HELPER
  // --------------------------------------------------
  const updateAsset = (index, updater) => {
    setSelectedAssets((prev) => {
      const copy = [...prev];
      copy[index] = updater(copy[index]);
      return copy;
    });
  };

  // --------------------------------------------------
  // ADD FILE (GENERIC)
  // --------------------------------------------------
  const addFile = (file, index) => {
    
    updateAsset(index, (a) => {
      const url = URL.createObjectURL(file);

      const exists = (a.data || []).some(
        (d) => d.file?.name === file.name && d.file?.size === file.size
      );

      if (exists) return a;

      return {
        ...a,
        data: [
          ...(a.data || []),
          {
            file,
            name: file.name,
            url,
          },
        ],
      };
    });
  };


   // --------------------------------------------------
  // SET MAIN IMAGE
  // --------------------------------------------------
 

  const setMainImage = (file, index) => {
    updateAsset(index, (asset) => ({
      ...asset,
      png: file,
      mainImageUrl: URL.createObjectURL(file),
    }));
  };

  // --------------------------------------------------
  // REMOVE FILE
  // --------------------------------------------------
  const removeFile = (assetIndex, fileIndex) => {
    updateAsset(assetIndex, (a) => {
      const item = a.data?.[fileIndex];

      if (item?.url) URL.revokeObjectURL(item.url);

      a.data = a.data.filter((_, i) => i !== fileIndex);

      return { ...a };
    });
  };

  // --------------------------------------------------
  // ADD ASSET (THIS SETS TYPE)
  // --------------------------------------------------
  const handleAddAsset = (type, name = "", defaultPng = null) => {
    setSelectedAssets((prev) => [
      ...prev,
      {
        id: null,
        name,
        png: null,
        mainImageUrl: defaultPng,
        type,
        data: [],
      },
    ]);
  };

  // --------------------------------------------------
  // REMOVE ASSET
  // --------------------------------------------------
  const handleRemoveAsset = (index) => {
    setSelectedAssets((prev) => {
      const copy = [...prev];
      const removed = copy.splice(index, 1)[0];

      if (removed?.id) {
        setDeletedAssets((p) => [...p, removed.id]);
      }

      return copy;
    });

    message.success("Asset removed");
  };

  // --------------------------------------------------
  // COMPILE
  // --------------------------------------------------
  const compileAssets = async (storyId) => {

    console.log("🔥 COMPILE ASSETS CALLED", storyId, new Date());

    const formData = new FormData();

    selectedAssets.forEach((asset, i) => {

      console.log("ASSET:", i, asset);

      formData.append(`asset${i}_id`, asset.id ?? 0);

      formData.append(`asset${i}_name`, asset.name);
      

      
if (asset.png instanceof File) {
  formData.append(`asset${i}_mainImg`, asset.png);
}

formData.append(
  `asset${i}_mainImgUrl`,
  asset.mainImageUrl || ""
);


      formData.append(`asset${i}_type`, asset.type);


      asset.data.forEach((item, di) => {


        console.log("asset.name>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>:", asset.name);

        console.log("ITEM:", di, item);
        console.log("FILE:", item.file);
        console.log("IS FILE:", item.file instanceof File);



        if (item.file instanceof File) {
          formData.append(
            `asset${i}_data${di}`,
            item.file
          );
        }

        // Always send metadata
        formData.append(
          `asset${i}_dataMeta${di}`,
          JSON.stringify({
            name: item.name,
            url: item.url
          })
        );











      });












    });

    for (const pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    console.log("compile assets:-", formData);

    const res = await axios.post(`/api/${storyId}/compile`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    setSelectedAssets(prev =>
      prev.map((asset, index) => ({
        ...asset,
        id: Number(res.data.data.assets[index].id),
      }))
    );

    message.success("Assets compiled successfully");
    return res.data;
  };

  // --------------------------------------------------
  // RETURN
  // --------------------------------------------------
  return {
    setSelectedAssets,

    addFile,
    removeFile,
    setMainImage,

    handleAddAsset,
    handleRemoveAsset,

    compileAssets,
  };
}